import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { tagKeys } from '@/shared/lib/query/queryKeys';

import { createTagApi } from '@/features/tags/api';
import type { CreateTagRequest } from '@/features/tags/api';

export const useCreateTag = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateTagRequest) => createTagApi(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: tagKeys.tags(variables.classification) });
      queryClient.invalidateQueries({ queryKey: tagKeys.categories() });
      queryClient.invalidateQueries({ queryKey: tagKeys.categoryDetail(variables.classification) });
      queryClient.invalidateQueries({ queryKey: tagKeys.tagsByCategory(variables.classification) });
      queryClient.invalidateQueries({ queryKey: tagKeys.availableTags() });

      notification.success({
        message: NOTIFICATION_MESSAGES.TAG_CREATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.TAG_CREATE_SUCCESS_DESC,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
